import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import appConfig from './config/app.json';
import './styles/theme.css';

const app = createApp(App);

app.config.globalProperties.$appConfig = appConfig;

app.mixin({
  computed: {
    brandName() {
      return appConfig.brand.name;
    },
    brandSubtitle() {
      return appConfig.brand.subtitle;
    },
    brandTagline() {
      return appConfig.brand.tagline;
    },
  },
});

function blockSiteZoom() {
  const blockedKeys = ['+', '-', '=', '_', '0']

  const onKeyDown = (e) => {
    const cmdOrCtrl = e.ctrlKey || e.metaKey
    if (cmdOrCtrl && blockedKeys.includes(e.key)) {
      e.preventDefault()
    }
  }

  const onWheel = (e) => {
    if (e.ctrlKey) {
      e.preventDefault()
    }
  }

  const onGesture = (e) => {
    e.preventDefault()
  }

  document.addEventListener('keydown', onKeyDown, { passive: false })
  document.addEventListener('wheel', onWheel, { passive: false })

  // Safari / iOS
  document.addEventListener('gesturestart', onGesture, { passive: false })
  document.addEventListener('gesturechange', onGesture, { passive: false })
  document.addEventListener('gestureend', onGesture, { passive: false })

  // double tap zoom fix
  let lastTouchEnd = 0
  document.addEventListener(
    'touchend',
    (e) => {
      const now = Date.now()
      if (now - lastTouchEnd <= 300) {
        e.preventDefault()
      }
      lastTouchEnd = now
    },
    { passive: false }
  )
}

blockSiteZoom()


app.use(store).use(router).mount('#app');

